/* Nomination ürün sayfası - Veritas Dijital */
(function () {
  'use strict';
  if (customElements.get('nm-product')) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  class NmProduct extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      var json = this.querySelector('[data-nm-variants]');
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.form = document.getElementById('product-form-' + this.sectionId);

      this.bindVariantPicker();
      this.bindQuantity();
      this.bindHavale();
      this.bindAccordions();
      this.bindGallery();
      this.bindLightbox();
      this.bindStickyBar();
      this.bindPopups();
      this.bindGiftCard();

      this.currentVariant = this.findVariant(this.getSelectedOptions()) || this.variants[0];
      this.updateInventory();
    }

    /* ---------- Varyant ---------- */
    getSelectedOptions() {
      var options = [];
      this.querySelectorAll('[data-nm-variant-picker] .nm-variants__option').forEach(function (opt) {
        var select = opt.querySelector('[data-nm-option-select]');
        if (select) {
          options.push(select.value);
        } else {
          var chip = opt.querySelector('.nm-chip.is-selected');
          options.push(chip ? chip.dataset.value : null);
        }
      });
      return options;
    }

    findVariant(options) {
      if (!options.length) return this.variants[0];
      return this.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === options[i]; });
      });
    }

    bindVariantPicker() {
      var picker = this.querySelector('[data-nm-variant-picker]');
      if (!picker) return;
      var self = this;
      picker.addEventListener('click', function (e) {
        var chip = e.target.closest('.nm-chip');
        if (!chip) return;
        var group = chip.parentElement;
        group.querySelectorAll('.nm-chip').forEach(function (c) {
          c.classList.toggle('is-selected', c === chip);
          c.setAttribute('aria-checked', c === chip ? 'true' : 'false');
        });
        var label = chip.closest('.nm-variants__option').querySelector('[data-nm-option-value]');
        if (label) label.textContent = chip.dataset.value;
        self.onVariantChange();
      });
      picker.addEventListener('change', function (e) {
        if (!e.target.matches('[data-nm-option-select]')) return;
        var label = e.target.closest('.nm-variants__option').querySelector('[data-nm-option-value]');
        if (label) label.textContent = e.target.value;
        self.onVariantChange();
      });
    }

    onVariantChange() {
      var variant = this.findVariant(this.getSelectedOptions());
      this.currentVariant = variant;
      this.toggleButtons(variant);
      if (!variant) return;

      this.querySelectorAll('[data-nm-variant-input]').forEach(function (input) { input.value = variant.id; });
      if (this.form) {
        var idInput = this.form.querySelector('input[name="id"]');
        if (idInput) idInput.value = variant.id;
      }
      window.history.replaceState({}, '', this.dataset.url + '?variant=' + variant.id);
      this.updateMedia(variant);
      this.updateInventory();
      this.renderInfo(variant);
    }

    toggleButtons(variant) {
      var available = variant && variant.available;
      var strings = window.variantStrings || {};
      var text = !variant ? strings.unavailable : available ? strings.addToCart : strings.soldOut;
      this.querySelectorAll('[data-nm-atc]').forEach(function (btn) {
        btn.disabled = !available;
        var span = btn.querySelector('[data-nm-atc-text]');
        if (span && text) span.textContent = text;
      });
      var sticky = this.querySelector('[data-nm-sticky-submit]');
      if (sticky) {
        sticky.disabled = !available;
        if (text) sticky.textContent = text;
      }
      this.querySelectorAll('[data-nm-havale]').forEach(function (btn) { btn.hidden = !available; });
    }

    renderInfo(variant) {
      var self = this;
      fetch(this.dataset.url + '?variant=' + variant.id + '&section_id=' + this.sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('[data-nm-update]').forEach(function (fresh) {
            var current = self.querySelector('[data-nm-update="' + fresh.dataset.nmUpdate + '"]');
            if (current) current.innerHTML = fresh.innerHTML;
          });
        })
        .catch(function () {});
    }

    updateInventory() {
      var box = this.querySelector('[data-nm-inventory]');
      if (!box) return;
      var v = this.currentVariant;
      var msgEl = box.querySelector('[data-nm-inventory-message]');
      var bar = box.querySelector('[data-nm-inventory-bar]');
      var threshold = parseInt(box.dataset.threshold, 10) || 0;
      var max = parseInt(box.dataset.max, 10) || 40;
      var showUntracked = box.dataset.showUntracked === 'true';
      var msg = '';
      var pct = 0;
      var level = 'bad';

      if (!v) {
        msg = '';
      } else if (!v.available) {
        msg = box.dataset.msgOut;
      } else if (!v.inventory_management) {
        if (showUntracked) { msg = box.dataset.msgIn; pct = 100; level = 'good'; }
      } else if (v.inventory_quantity > 0) {
        pct = Math.min(100, (v.inventory_quantity / max) * 100);
        if (threshold > 0 && v.inventory_quantity <= threshold) {
          msg = box.dataset.msgLow.replace('[count]', v.inventory_quantity);
          level = 'medium';
        } else {
          msg = box.dataset.msgIn;
          level = 'good';
        }
      } else if (v.inventory_policy === 'continue') {
        msg = box.dataset.msgBack;
        level = 'medium';
        pct = 100;
      } else {
        msg = box.dataset.msgOut;
      }

      box.hidden = !msg;
      if (msgEl) msgEl.textContent = msg || ' ';
      if (bar) {
        bar.style.width = pct + '%';
        bar.dataset.level = level;
      }
    }

    /* ---------- Adet ---------- */
    bindQuantity() {
      this.querySelectorAll('[data-nm-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var input = btn.parentElement.querySelector('input');
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.nmQty, 10));
          input.value = next;
        });
      });
    }

    /* ---------- EFT / Havale ---------- */
    bindHavale() {
      var self = this;
      this.querySelectorAll('[data-nm-havale]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var original = btn.innerHTML;
          btn.disabled = true;
          btn.innerHTML = '...';
          var qtyInput = document.getElementById('Quantity-' + self.sectionId);
          var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
          var id = self.currentVariant ? self.currentVariant.id : null;
          if (!id) { btn.disabled = false; btn.innerHTML = original; return; }
          fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: id, quantity: qty })
          })
            .then(function (r) { if (!r.ok) throw new Error(); })
            .then(function () {
              return fetch(root + 'cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: { odeme_yontemi: 'havale' } })
              });
            })
            .then(function () { window.location.href = root + 'checkout?discount=HAVALE5'; })
            .catch(function () { btn.disabled = false; btn.innerHTML = original; });
        });
      });
    }

    /* ---------- Açılır satırlar ---------- */
    bindAccordions() {
      if (this.dataset.autoCollapse !== 'true') return;
      var items = this.querySelectorAll('[data-nm-accordion]');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) { if (other !== item) other.open = false; });
        });
      });
    }

    /* ---------- Galeri ---------- */
    bindGallery() {
      var gallery = this.querySelector('[data-nm-gallery]');
      if (!gallery) return;
      this.galleryList = gallery.querySelector('[data-nm-gallery-list]');

      var more = gallery.querySelector('[data-nm-more-media]');
      if (more) {
        more.addEventListener('click', function () {
          var expanded = gallery.classList.toggle('is-expanded');
          more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          more.querySelector('[data-more]').hidden = expanded;
          more.querySelector('[data-less]').hidden = !expanded;
        });
      }

      var dots = gallery.querySelectorAll('.nm-gallery__dot');
      if (dots.length) {
        var list = this.galleryList;
        list.addEventListener('scroll', function () {
          var index = Math.round(list.scrollLeft / list.clientWidth);
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
        }, { passive: true });
      }
    }

    updateMedia(variant) {
      if (!variant.featured_media || !this.galleryList) return;
      var item = this.galleryList.querySelector('[data-media-id="' + variant.featured_media + '"]');
      if (!item) return;
      this.galleryList.querySelectorAll('.nm-gallery__item').forEach(function (el) { el.classList.toggle('is-active', el === item); });
      item.classList.remove('is-overflow');
      if (window.matchMedia('(max-width: 959px)').matches) {
        this.galleryList.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      } else if (item.getBoundingClientRect().top < 0 || item.getBoundingClientRect().top > window.innerHeight) {
        item.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    /* ---------- Lightbox ---------- */
    bindLightbox() {
      var box = this.querySelector('[data-nm-lightbox]');
      if (!box) return;
      var self = this;
      this.querySelectorAll('[data-nm-zoom]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          box.hidden = false;
          document.body.classList.add('nm-scroll-lock');
          var slide = box.querySelector('.nm-lightbox__slide[data-index="' + btn.dataset.nmZoom + '"]');
          requestAnimationFrame(function () {
            box.classList.add('is-open');
            if (slide) slide.scrollIntoView({ block: 'start' });
            box.querySelector('[data-nm-lightbox-close]').focus();
          });
          self.lightboxOpener = btn;
        });
      });
      var close = function () {
        box.classList.remove('is-open');
        box.hidden = true;
        document.body.classList.remove('nm-scroll-lock');
        if (self.lightboxOpener) self.lightboxOpener.focus();
      };
      box.querySelector('[data-nm-lightbox-close]').addEventListener('click', close);
      box.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }

    /* ---------- Yapışkan sepete ekle ---------- */
    bindStickyBar() {
      var bar = this.querySelector('[data-nm-sticky-atc]');
      var atc = this.querySelector('[data-nm-atc]');
      if (!bar || !atc || !('IntersectionObserver' in window)) return;
      var self = this;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(atc);
      var change = bar.querySelector('[data-nm-sticky-change]');
      if (change) {
        change.addEventListener('click', function () {
          var picker = self.querySelector('[data-nm-variant-picker]');
          if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
      bar.querySelector('[data-nm-sticky-submit]').addEventListener('click', function () {
        if (!self.form) return;
        if (self.form.requestSubmit) {
          self.form.requestSubmit(self.form.querySelector('[name="add"]'));
        } else {
          self.form.querySelector('[name="add"]').click();
        }
      });
    }

    /* ---------- Beden rehberi popup ---------- */
    bindPopups() {
      this.querySelectorAll('[data-nm-popup-open]').forEach(function (btn) {
        var popup = document.getElementById(btn.dataset.nmPopupOpen);
        if (!popup) return;
        btn.addEventListener('click', function () {
          popup.hidden = false;
          document.body.classList.add('nm-scroll-lock');
          popup.querySelector('[data-nm-popup-close].nm-popup__close').focus();
        });
        var close = function () {
          popup.hidden = true;
          document.body.classList.remove('nm-scroll-lock');
          btn.focus();
        };
        popup.querySelectorAll('[data-nm-popup-close]').forEach(function (c) { c.addEventListener('click', close); });
        popup.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      });
    }

    /* ---------- Hediye kartı ---------- */
    bindGiftCard() {
      var toggle = this.querySelector('[data-nm-gc-toggle]');
      if (!toggle) return;
      var fields = this.querySelector('[data-nm-gc-fields]');
      toggle.addEventListener('change', function () {
        fields.hidden = !toggle.checked;
        fields.querySelectorAll('input, textarea').forEach(function (el) { el.disabled = !toggle.checked; });
      });
    }
  }

  customElements.define('nm-product', NmProduct);
})();
